import { Injectable } from '@angular/core';
import { Theme } from 'studio-components/shared/types/theme.type';

// provide at component level to access the theme further down the component tree
@Injectable()
export class ThemeProviderService {
  private theme: Theme;

  public setTheme(theme: Theme) {
    this.theme = theme;
  }

  public getTheme() {
    return this.theme;
  }
}
